"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const project_1 = require("@becrop/components/Results/Abstract/Interfaces/project");
const EntityItem_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/Projects/EntityItem.vue"));
let ProjectSelector = class ProjectSelector extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.entityActiveInSelect = null;
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    fillEntityActiveInSelect() {
        if (this.isAreaProjectBuilt(this.entitySelected)) {
            const entity = this.entitySelected;
            return this.curatedOptions.find((e) => e.type === 'projects' &&
                e.id === entity.area_id &&
                e.projId === entity.project_id);
        }
        if (this.isFarm(this.entitySelected)) {
            const entity = this.entitySelected;
            return this.curatedOptions.find((e) => e.type === 'farms' &&
                e.id === entity.id);
        }
        return null;
    }
    get curatedOptions() {
        const curatedFarms = this.farms.map((f) => {
            return new project_1.Entity({
                type: 'farms',
                label: f.name,
                name: f.name,
                id: f.id,
                projId: -1,
                acreage: f.acreage,
                projType: '',
                cropLabel: f.cropLabel,
                cropColor: f.cropColor
            });
        });
        const curatedProjects = this.curatedProjects.map((p) => {
            return new project_1.Entity({
                type: 'projects',
                label: p.label,
                name: p.area_name,
                id: p.area_id,
                projId: p.project_id,
                acreage: p.acreage,
                projType: p.project_type,
                cropLabel: p.area_crop.name,
                cropColor: p.area_crop.color,
                // @ts-ignore
                dateRangeLabel: p === null || p === void 0 ? void 0 : p.dateRangeLabel
            });
        });
        return [...curatedProjects, ...curatedFarms];
    }
    get curatedProjects() {
        if (this.disabledProject)
            return this.projects.filter((p) => p !== this.disabledProject);
        return this.projects;
    }
    get isMainLoading() {
        return this.loadingDetailStatus.type == 'delivery' || this.loadingDetailStatus.type == 'list' || this.loadingDetailStatus.type == 'farms';
    }
    get isSecondaryLoading() {
        return this.loadingDetailStatus.type == 'delivery2';
    }
    get isLoading() {
        if (this.isMainSelector) {
            return this.isMainLoading;
        }
        else {
            return this.isSecondaryLoading;
        }
    }
    get myMessage() {
        var _a, _b, _c, _d, _e;
        if (this.isMainSelector) {
            if (this.loadingDetailStatus.type === 'delivery' || this.loadingDetailStatus.type === 'farms') {
                return this.loadingDetailStatus.message;
            }
            else {
                if (((_a = this.entityActiveInSelect) === null || _a === void 0 ? void 0 : _a.type) === 'projects') {
                    let label = this.entityActiveInSelect.projType.charAt(0).toUpperCase() + ' - ' + this.entityActiveInSelect.name;
                    if (this.entityActiveInSelect.dateRangeLabel && this.entityActiveInSelect.dateRangeLabel !== '---')
                        label += ' (' + this.entityActiveInSelect.dateRangeLabel + ')';
                    return label;
                }
                if (((_b = this.entityActiveInSelect) === null || _b === void 0 ? void 0 : _b.type) === 'farms') {
                    return this.entityActiveInSelect.name;
                }
            }
        }
        else {
            if (this.loadingDetailStatus.type === 'delivery2') {
                return this.loadingDetailStatus.message;
            }
            else {
                return ((_d = (_c = this.projectSelected) === null || _c === void 0 ? void 0 : _c.project_type) === null || _d === void 0 ? void 0 : _d.charAt(0).toUpperCase()) + ' - ' + ((_e = this.projectSelected) === null || _e === void 0 ? void 0 : _e.area_name);
            }
        }
    }
    isAreaProjectBuilt(entity) {
        return 'area_id' in entity;
    }
    isFarm(entity) {
        return 'id' in entity;
    }
    updateEntitySelected(model) {
        if (model.type === 'projects') {
            const project = this.curatedProjects.find((p) => p.area_id === model.id && p.project_id === model.projId);
            this.$emit('updateProjectSelected', project);
        }
        else if (model.type === 'farms') {
            const farm = this.farms.find((f) => f.id === model.id);
            this.$emit('updateFarmSelected', farm);
        }
    }
    updateProjectActive() {
        this.entityActiveInSelect = this.fillEntityActiveInSelect();
    }
    mounted() {
        this.entityActiveInSelect = this.fillEntityActiveInSelect();
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: (Array), default: [] })
], ProjectSelector.prototype, "projects", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], ProjectSelector.prototype, "projectSelected", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], ProjectSelector.prototype, "entitySelected", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], ProjectSelector.prototype, "disabledProject", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], ProjectSelector.prototype, "isMainSelector", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], ProjectSelector.prototype, "loadingDetailStatus", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ProjectSelector.prototype, "currentFarm", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: [] })
], ProjectSelector.prototype, "farms", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], ProjectSelector.prototype, "entityType", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], ProjectSelector.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('entitySelected')
], ProjectSelector.prototype, "updateProjectActive", null);
ProjectSelector = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Select: bmk_ui_framework_1.Select,
            EntityItem: EntityItem_vue_1.default
        },
    })
], ProjectSelector);
exports.default = ProjectSelector;
